const { Table } = window.Material;

import TableHead, { TableHeadProps } from './TableHead';
import TableBody, { TableBodyProps } from './TableBody';
import TablePagination, { TablePaginationProps } from './TablePagination';
import { RefObject } from 'react';

interface TableProps extends TableHeadProps, TableBodyProps, TablePaginationProps {}

export default class EdocatTable extends React.PureComponent<TableProps> {
  
  tableRef: RefObject<HTMLDivElement>;
  constructor(props: TableProps) {
    super(props);
    this.tableRef = React.createRef<HTMLDivElement>();
  }

  componentDidUpdate(prevProps: TableProps) {
    const { data } = this.props;
    // If current data changes -> automatically scrolls the table up
    if(prevProps.data !== data) {
      if(this.tableRef.current) {
        this.tableRef.current.scrollTop = 0;
      }
    } 
  }

  render() {
    const {
      tableName,
      tableHeaders,
      sortObj,
      tableSortHandler,
      data,
      pagination,
      tablePageChangeHandler,
      onRowsPerPageChangeHandler,
      rowsPerPageOptions,
      noDataText,
    } = this.props;

    return (
      <div ref={this.tableRef}>
        <Table>
          <TableHead
            sortObj={sortObj}
            tableHeaders={tableHeaders}
            tableName={tableName}
            tableSortHandler={tableSortHandler}
            showSort={pagination?.total > 0}
          />

          <TableBody data={data} tableHeaders={tableHeaders} noDataText={noDataText} />
        </Table>

        {pagination && pagination.total > 0 && (
          <TablePagination
            pagination={pagination}
            tableName={tableName}
            tablePageChangeHandler={tablePageChangeHandler}
            onRowsPerPageChangeHandler={onRowsPerPageChangeHandler}
            rowsPerPageOptions={rowsPerPageOptions}
          />
        )}
      </div>
    );
  }
}
